export default __webpack_public_path__ + "static/media/icon-mail.fa0ecb7c.svg";